module.exports = __webpack_public_path__ + "static/media/bestbuy-logo.19cfdd58.svg";